import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { getShipmentDetail, patchShipment } from "../../api/imports";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

const ShipmentIncrementalsForm = ({ props }) => {
  const { id, onSubmit } = props;
  const { openSnack } = useSnack();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    oceanFreightCost: "",
    customsAgentCost: "",
    forwarderLandCost: "",
    storageCost: "",
    delayCharges: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await getShipmentDetail(id);
        setFormData({
          oceanFreightCost: res.data.oceanFreightCost ?? "",
          customsAgentCost: res.data.customsAgentCost ?? "",
          forwarderLandCost: res.data.forwarderLandCost ?? "",
          storageCost: res.data.storageCost ?? "",
          delayCharges: res.data.delayCharges ?? 0,
        });
      } catch (e) {
        openSnack(handleError(e), "error");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, openSnack]);

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await patchShipment(id, {
        oceanFreightCost:
          formData.oceanFreightCost === ""
            ? null
            : parseFloat(formData.oceanFreightCost),
        customsAgentCost:
          formData.customsAgentCost === ""
            ? null
            : parseFloat(formData.customsAgentCost),
        forwarderLandCost:
          formData.forwarderLandCost === ""
            ? null
            : parseFloat(formData.forwarderLandCost),
        storageCost:
          formData.storageCost === ""
            ? null
            : parseFloat(formData.storageCost),
      });
      openSnack("Incrementables actualizados exitosamente", "success");
      onSubmit();
    } catch (e) {
      openSnack(handleError(e), "error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Incrementables
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Flete Marítimo (USD)"
            type="number"
            value={formData.oceanFreightCost}
            onChange={handleChange("oceanFreightCost")}
            InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Agente Aduanal (MXN)"
            type="number"
            value={formData.customsAgentCost}
            onChange={handleChange("customsAgentCost")}
            InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Forwarder Terrestre (MXN)"
            type="number"
            value={formData.forwarderLandCost}
            onChange={handleChange("forwarderLandCost")}
            InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Almacenaje (MXN)"
            type="number"
            value={formData.storageCost}
            onChange={handleChange("storageCost")}
            InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Recargos por Demora (USD)"
            type="number"
            value={formData.delayCharges}
            disabled
            InputProps={{ inputProps: { min: 0, step: 0.01 } }}
          />
        </Grid>
      </Grid>
      <Button
        variant="contained"
        fullWidth
        onClick={handleSave}
        disabled={saving}
        sx={{ mt: 3 }}
      >
        {saving ? "Guardando..." : "Guardar"}
      </Button>
    </Box>
  );
};

export default ShipmentIncrementalsForm;
